require('svg4everybody')({"polyfill":true});
